import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locals/en.json';
import ar from './locals/ar.json';

const resources = {
  en: { translation: en },
  ar: { translation: ar }
};

i18n
       // auto detect language from browser
  .use(initReactI18next)      // passes i18n down to react-i18next
  .init({
  resources,
  lng: 'en',           // ✅ Force English as default
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
